
import Vue from 'vue';

import Odometer from 'odometer';

Vue.directive('odometer', {
  inserted: function inserted(el, _ref) {
    var value = _ref.value;


    var od = new Odometer({
      el: el,
      value: 0,
      format: '',
      theme: 'minimal'
    });
  }
});


//////////////////
// WEBPACK FOOTER
// ./directives/odometer.js
// module id = ./directives/odometer.js
// module chunks = 5